export default __webpack_public_path__ + "static/icons-bg-red-f5224085e42dfd20220fc796afa88728.svg";